import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getTrackingSettings } from '../lib/hooks/useTrackingSettings';
import { applyTrackingSettings, trackPageView } from '../lib/tracking';

/**
 * Зарежда таговете (Google Tag Manager, GA4, Google Ads, Meta Pixel, собствен
 * код), конфигурирани от админ панела -> Проследяване. Админ панелът не се
 * проследява.
 */
const TrackingScripts = () => {
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith('/admin');
  const [ready, setReady] = useState(false);
  const loadedRef = useRef(false);
  const trackedPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (isAdminRoute || loadedRef.current) return;
    loadedRef.current = true;

    getTrackingSettings()
      .then((settings) => {
        applyTrackingSettings(settings);
        setReady(true);
      })
      .catch((error) => {
        console.error('Error loading tracking settings:', error);
      });
  }, [isAdminRoute]);

  useEffect(() => {
    if (isAdminRoute || !ready) return;

    // Първото зареждане се отчита от самия таг, затова се проследяват само
    // последващите смени на страницата.
    if (trackedPathRef.current === null) {
      trackedPathRef.current = pathname;
      return;
    }

    if (trackedPathRef.current === pathname) return;

    trackedPathRef.current = pathname;
    trackPageView(pathname);
  }, [pathname, isAdminRoute, ready]);

  return null;
};

export default TrackingScripts;
